<template>
  <v-container class="d-flex justify-center">
    <v-card v-if="!success" class="pa-4" width="500">
      <v-card-title class="pa-0">Forgot Password</v-card-title>
      <p>Enter your email and a link will be sent for you to reset your password</p>
      <p id="errorMsg" class="red--text" hidden>No account is registered with the email {{ failedEmail }}</p>
      <v-form v-model="isValid" @submit.prevent ref="form">
        <v-text-field label="email" v-model="email" :rules="[rules.validEmail]" @keyup.enter="send"></v-text-field>
        <v-btn @click="send" :disabled="!isValid" :loading="loading" color="accent" class="float-end">Send</v-btn>
      </v-form>
      <!-- div margin top to account for float right button -->
      <div v-if="emailBlocked" id="blacklistedEmailResponse" class="mt-10">
        <v-divider></v-divider>
        <p>
          The email address has been blocked from receiving emails either because it does not exist or has reported
          Telemonial to its email provider. To reactivate this address, send an email to
          <a href="mailto:support@telemonial.com">support@telemonial.com</a>. You may have to check your spam folder for
          any responses.
        </p>
      </div>
    </v-card>

    <v-card v-else class="pa-4" width="500">
      <v-card-title class="px-0">
        A link has been emailed to<br />
        {{ email }}.
      </v-card-title>
      <v-card-text class="px-0 black--text">
        The link will be valid for 15 minutes.<br />
        If you do not see the email within a few minutes, check your spam folder.
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "forgot-password.vue",

  data: function () {
    return {
      email: "",

      isValid: false,
      rules: {
        validEmail: (val) => {
          //regex grabbed from emailregex.com to match email addresses. Removed 2 "unnecessary escapes"--watch for bugs.
          const regex =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return regex.exec(val) !== null || "Invalid Email";
        },
      },

      loading: false,
      failedEmail: "",
      success: false,

      emailBlocked: false,
    };
  },

  methods: {
    ...mapMutations(["showSnackbar"]),

    send: function () {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      this.$axios
        .post("/forgot-password", {
          email: this.email,
        })
        .then(() => {
          // Notify user that email has been sent
          this.success = true;
          // Make sure error message goes away
          this.failedEmail = "";
          this.emailBlocked = false;
          document.getElementById("errorMsg").hidden = true;
        })
        .catch((err) => {
          if (err.response.data && err.response.data.message.startsWith("No account with email")) {
            this.failedEmail = this.email;
            document.getElementById("errorMsg").hidden = false;
          } else if (err.response.data && err.response.data.message === "Email blacklisted") {
            console.log("Email blacklisted");
            this.emailBlocked = true;
          } else {
            this.showSnackbar({
              text: "An unexpected error has occurred!",
              error: true,
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>
